/**
 * Copyright 2023 Nordcloud Oy or its affiliates. All Rights Reserved.
 */

export function getTypedKeys<T>(obj: T): Array<keyof T> {
  return Object.keys(obj as keyof T) as Array<keyof typeof obj>;
}
